export default "__VITE_ASSET__922e2295__"